// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Js_json = require("bs-platform/lib/js/js_json.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Json$BwaxMobile = require("../../../../bwax-js/ml/utils/json.bs.js");
var Plate$BwaxMobile = require("../../../../bwax-js/ml/plate.bs.js");
var Lang_eval$BwaxMobile = require("../../../../bwax-js/ml/lang/lang_eval.bs.js");
var Runtime_common$BwaxMobile = require("../../../../bwax-js/ml/lang/mod/runtime_common.bs.js");
var Widget_html_common$BwaxMobile = require("./widget_html_common.bs.js");

var module_name = "LocalFile";

var src = "\nmodule " + (String(module_name) + ";\n\n-- File name, or file title\nname : LocalFile -> String = external;\n\nsize: LocalFile -> Int = external;\n\n-- \nfileType: LocalFile -> File.FileType = external;\n\n");

function fail(name) {
  throw [
        Lang_eval$BwaxMobile.Eval_exn,
        module_name + ("." + (name + ": Invalid Arguments"))
      ];
}

function pack_getter(decoder, pack, name) {
  return Runtime_common$BwaxMobile.pack_func(1, (function (param) {
                if (param) {
                  var match = param[0][0];
                  if (typeof match === "number" || !(match.tag === /* V_tagged_raw */8 && match[0] === "LocalFile" && !param[1])) {
                    return fail(name);
                  } else {
                    var match$1 = Json$BwaxMobile.get_value(name, decoder, match[1]);
                    if (match$1 !== undefined) {
                      return Curry._1(pack, Caml_option.valFromOption(match$1));
                    } else {
                      return fail(name);
                    }
                  }
                } else {
                  return fail(name);
                }
              }));
}

function attribute_msg_func(name) {
  return /* tuple */[
          name,
          Widget_html_common$BwaxMobile.pack_attribute_func(1, (function (param) {
                  if (param && !param[1]) {
                    return /* Attribute_event_msg */Block.__(4, [
                              name,
                              param[0]
                            ]);
                  } else {
                    return fail(name);
                  }
                }))
        ];
}

function attribute_string_msg_func(name) {
  return /* tuple */[
          name,
          Widget_html_common$BwaxMobile.pack_attribute_func(1, (function (param) {
                  if (param && !param[1]) {
                    var f = param[0];
                    var handle_event = function (s) {
                      return Lang_eval$BwaxMobile.apply_value(undefined, f, /* tuple */[
                                  /* V_literal */Block.__(5, [/* String */Block.__(2, [s])]),
                                  Runtime_common$BwaxMobile.nt
                                ], Runtime_common$BwaxMobile.nt);
                    };
                    return /* Attribute_event_string_msg */Block.__(5, [
                              name,
                              handle_event
                            ]);
                  } else {
                    return fail(name);
                  }
                }))
        ];
}

var externals_vals_000 = /* tuple */[
  "fileType",
  Runtime_common$BwaxMobile.pack_func(1, (function (param) {
          if (param) {
            var match = param[0][0];
            if (typeof match === "number" || !(match.tag === /* V_tagged_raw */8 && match[0] === "LocalFile" && !param[1])) {
              return fail("fileType");
            } else {
              var image_000 = /* V_tagged */Block.__(6, [
                  "IMAGE",
                  /* [] */0
                ]);
              var image = /* tuple */[
                image_000,
                Runtime_common$BwaxMobile.nt
              ];
              var doc_000 = /* V_tagged */Block.__(6, [
                  "DOC",
                  /* [] */0
                ]);
              var doc = /* tuple */[
                doc_000,
                Runtime_common$BwaxMobile.nt
              ];
              var pdf_000 = /* V_tagged */Block.__(6, [
                  "PDF",
                  /* [] */0
                ]);
              var pdf = /* tuple */[
                pdf_000,
                Runtime_common$BwaxMobile.nt
              ];
              var xls_000 = /* V_tagged */Block.__(6, [
                  "XLS",
                  /* [] */0
                ]);
              var xls = /* tuple */[
                xls_000,
                Runtime_common$BwaxMobile.nt
              ];
              var ppt_000 = /* V_tagged */Block.__(6, [
                  "PPT",
                  /* [] */0
                ]);
              var ppt = /* tuple */[
                ppt_000,
                Runtime_common$BwaxMobile.nt
              ];
              var other_000 = /* V_tagged */Block.__(6, [
                  "OTHER",
                  /* [] */0
                ]);
              var other = /* tuple */[
                other_000,
                Runtime_common$BwaxMobile.nt
              ];
              var maybeContentType = Json$BwaxMobile.get_value("type", Js_json.decodeString, match[1]);
              if (maybeContentType !== undefined) {
                var v = Plate$BwaxMobile.Str.to_lower(maybeContentType);
                if (Plate$BwaxMobile.Str.starts_with(v, "image")) {
                  return image;
                } else if (Plate$BwaxMobile.Str.starts_with(v, "application/pdf")) {
                  return pdf;
                } else if (Plate$BwaxMobile.Str.starts_with(v, "application/vnd.ms-powerpoint") || Plate$BwaxMobile.Str.starts_with(v, "application/vnd.openxmlformats-officedocument.presentationml.presentation")) {
                  return ppt;
                } else if (Plate$BwaxMobile.Str.starts_with(v, "application/vnd.ms-excel") || Plate$BwaxMobile.Str.starts_with(v, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
                  return xls;
                } else if (Plate$BwaxMobile.Str.starts_with(v, "application/msword") || Plate$BwaxMobile.Str.starts_with(v, "application/vnd.openxmlformats-officedocument.wordprocessingml.document")) {
                  return doc;
                } else {
                  return other;
                }
              } else {
                return other;
              }
            }
          } else {
            return fail("fileType");
          }
        }))
];

var externals_vals_001 = /* :: */[
  /* tuple */[
    "name",
    pack_getter(Js_json.decodeString, Runtime_common$BwaxMobile.pack_string, "name")
  ],
  /* :: */[
    /* tuple */[
      "size",
      pack_getter(Js_json.decodeNumber, (function (param) {
              return Plate$BwaxMobile.$at$great((function (prim) {
                            return prim | 0;
                          }), Runtime_common$BwaxMobile.pack_int, param);
            }), "size")
    ],
    /* [] */0
  ]
];

var externals_vals = /* :: */[
  externals_vals_000,
  externals_vals_001
];

var externals_000 = module_name;

var externals = /* tuple */[
  externals_000,
  externals_vals
];

exports.module_name = module_name;
exports.src = src;
exports.fail = fail;
exports.pack_getter = pack_getter;
exports.attribute_msg_func = attribute_msg_func;
exports.attribute_string_msg_func = attribute_string_msg_func;
exports.externals_vals = externals_vals;
exports.externals = externals;
/* src Not a pure module */
